module.exports = __webpack_public_path__ + "img/iocn6.f9706f7b.png";